import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { getEnv } from '@config';
import crypto from 'crypto';

const { country, bffURL } = getEnv();

const generateCacheBuster = () => crypto.randomBytes(8).toString('hex');

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'es',
    fallbackLng: 'es',
    ns: ['cl'],
    debug: false,
    defaultNS: 'cl',
    backend: {
      loadPath: `${bffURL}/merchant/bff/merchant-wording/messages?cache=${generateCacheBuster()}`,
      crossDomain: false,
      customHeaders: {
        'x-flow-country': country,
      },
      parse(data) {
        return JSON.parse(data).payload;
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
      // wait: true,
    },
  });

export default i18n;
